import { render, staticRenderFns } from "./GoalsByClients.vue?vue&type=template&id=134cfbdc&scoped=true"
import script from "./GoalsByClients.vue?vue&type=script&lang=js"
export * from "./GoalsByClients.vue?vue&type=script&lang=js"
import style0 from "./GoalsByClients.vue?vue&type=style&index=0&id=134cfbdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134cfbdc",
  null
  
)

export default component.exports